// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__8B4nB","spinner":"Button_spinner__smDWZ","spin":"Button_spin__KIfnD"};